import React, { Component } from "react"
import Axios from "axios"
import * as JsSearch from "js-search"
import { Link } from "gatsby"

class Search extends Component {
  state = {
    bookList: [],//JSONの内容を格納
    search: [],//JsSearchインスタンスを格納
    searchResults: [],//検索結果を格納
    searchQuery: "",//検索ワード
  }
  /**
   * 初期化 search.jsonを読み込む
   */
  async componentDidMount() {
    Axios.get("search.json")
      .then(result => {
        const bookData = result
        this.setState({ bookList: bookData.data })
        this.rebuildIndex()
      })
      .catch(err => {

      })
  }

  /**
   * 検索方法の設定
   */
  rebuildIndex = () => {
    const { bookList } = this.state;
    // JsSearchインスタンス作成（検索対象のリストでユニークとなるキーを指定する）
    const dataToSearch = new JsSearch.Search("slug");

    // 検索ワードをいい感じに変換する（とりあえずスペースで分割し、複数文字列で検索）
    dataToSearch.tokenizer = {
      tokenize( text ) {
        return text.split(/\s+/i);      
      }
    };
    
    // 部分一致で検索する    
    dataToSearch.indexStrategy = new JsSearch.AllSubstringsIndexStrategy();
    
    // 検索ワードを小文字変換、trimする（記述しなくてもデフォルトで設定されている）
    dataToSearch.sanitizer = new JsSearch.LowerCaseSanitizer();
    
    //検索方法の設定
    dataToSearch.searchIndex = new JsSearch.TfIdfSearchIndex("slug");
    
    // 検索を行うキー
    dataToSearch.addIndex("title");
    dataToSearch.addIndex("search");
    
    // 検索対象となるリストを設定
    dataToSearch.addDocuments(bookList);
    this.setState({ search: dataToSearch });
  }

  /**
   * 検索ワード変更時に検索を行う
   */
  searchData = e => {
    const { search } = this.state
    const queryResult = search.search(e.target.value);
    this.setState({ searchQuery: e.target.value, searchResults: queryResult })
  }

  render() {
    const { bookList, searchResults, searchQuery } = this.state
    const queryResults = searchQuery === "" ? bookList : searchResults
    return (
        <div >
            <div>
            検索ワード：<input id="Search" value={searchQuery} onChange={this.searchData} />
            </div>
          <div>
            検索結果：{queryResults.length}
                {queryResults.map(item => {
                  return (
                      <div key={item.slug}>
                        <span>{item.date}</span>
                        <Link to={`/blog/${item.slug}`}>{item.title}</Link>
                      </div>
                  )
                })}
          </div>
        </div>
    )
  }
}
export default Search